import type React from "react";
import styles from "./MapLayersBar.module.css";
import { MapLayerType } from "../../types";

import AltRouteIcon from "@mui/icons-material/AltRoute";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";

type MapLayerBarProps = {
    getLayerVisibility: (layer: MapLayerType) => boolean;
    toggleLayerVisibility: (layer: MapLayerType) => void;
};

export default function MapLayersBar({ getLayerVisibility, toggleLayerVisibility }: MapLayerBarProps) {
    return (
        <div className={styles.bar}>
            <LayerButton
                label="ТС"
                title="Транспортные средства"
                active={getLayerVisibility("tsPoints")}
                onClick={() => toggleLayerVisibility("tsPoints")}
            />
            <LayerButton
                label="КП"
                title="Контейнерные площадки"
                active={getLayerVisibility("basePoints")}
                onClick={() => toggleLayerVisibility("basePoints")}
            />
            <LayerButton
                icon={<AltRouteIcon fontSize="small" />}
                title="Маршруты"
                active={getLayerVisibility("routes")}
                onClick={() => toggleLayerVisibility("routes")}
            />
            <LayerButton
                icon={<DoNotDisturbOnOutlinedIcon fontSize="small" />}
                title="Зоны ограничений"
                active={getLayerVisibility("restrictedZones")}
                onClick={() => toggleLayerVisibility("restrictedZones")}
            />
        </div>
    );
}

function LayerButton({
                         label,
                         icon,
                         title,
                         active,
                         onClick,
                     }: {
    label?: string;
    icon?: React.ReactNode;
    title: string;
    active: boolean;
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            className={`${styles.btn} ${active ? styles.active : ""}`}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            aria-label={title}
        >
            {label ? <span className={styles.text}>{label}</span> : icon}

            <span className={styles.tooltip} role="tooltip">
                {title}
            </span>
        </button>
    );
}
